import React from "react";
import { Box, Typography, Grid } from "@mui/material";

const companies = [
  {
    name: "Verafin",
    logo: "https://cakeyhand.s3.ca-central-1.amazonaws.com/prod/general/companies_we_work_with/verafin-logo.png",
  },
  {
    name: "Cenovus",
    logo: "https://cakeyhand.s3.ca-central-1.amazonaws.com/prod/general/companies_we_work_with/cenovusLogo.png",
  },
  {
    name: "ExxonMobil",
    logo: "https://cakeyhand.s3.ca-central-1.amazonaws.com/prod/general/companies_we_work_with/exxonmobilLogo.png",
  },
  {
    name: "Hudson & Rex",
    logo: "https://cakeyhand.s3.ca-central-1.amazonaws.com/prod/general/companies_we_work_with/hudsonAndRexLogo.jpeg",
  },
  {
    name: "Propel",
    logo: "https://cakeyhand.s3.ca-central-1.amazonaws.com/prod/general/companies_we_work_with/propelLogo.png",
  },
  {
    name: "O'Neill Group",
    logo: "https://cakeyhand.s3.ca-central-1.amazonaws.com/prod/general/companies_we_work_with/oneill_auto_group.png",
  },
];

const CompanyLogosStrip = () => {
  return (
    <Box sx={{ backgroundColor: "#f1f1f1", py: 6, textAlign: "center" }}>
      <Typography
        variant="h4"
        sx={{
          fontWeight: "bold",
          mb: 4,
          fontFamily: "Moul",
        }}>
        Trusted by Companies like
      </Typography>

      <Grid container spacing={4} justifyContent="center">
        {companies.map((company, index) => (
          <Grid item xs={6} sm={4} md={2} key={index}>
            <Box
              component="img"
              src={company.logo}
              alt={company.name}
              sx={{
                width: "150px",
                height: "80px",
                objectFit: "contain",
                margin: "0 auto",
                display: "block",
              }}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default CompanyLogosStrip;
